module.exports = __webpack_public_path__ + "img/queren.261e649c.png";